export const SINGLE_GET_LOADING = "singlePage/get/loading"

export const SINGLE_GET_ERROR = "singlePage/get/error"

export const SINGLE_GET_SUCCESS = "singlePage/get/success"